import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Alert,
    CircularProgress,
    Button,
    Paper,
} from "@mui/material";

const KASSE_ENDPOINT = "https://fkcrenezvf.execute-api.eu-central-1.amazonaws.com/Prod";
const AUTH_SECRET = "supersecret";

const authHeaders = {
    headers: {
        Authorization: `Bearer ${AUTH_SECRET} y 1 z`,
    },
};

export default function OpenTransactionStatus({ clientId, onLoad }) {
    const [openTransactions, setOpenTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchStatus = async () => {
        setLoading(true);
        setError(null);
        try {
            const url = clientId
                ? `${KASSE_ENDPOINT}/status?client_id=${clientId}`
                : `${KASSE_ENDPOINT}/status`;
            const { data } = await axios.get(url, authHeaders);
            setOpenTransactions(data.open_transactions || []);
        } catch (err) {
            setError("Fehler beim Laden der Statusinformationen.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStatus();
    }, [clientId]);

    if (loading) return <CircularProgress />;
    if (error) return <Alert severity="error">{error}</Alert>;
    if (openTransactions.length === 0) return null;

    return (
        <Paper elevation={3} sx={{ p: 3, mb: 4, backgroundColor: "#fff8e1" }}>
            <Typography variant="h6" color="error" gutterBottom>
                ⚠️ Es gibt offene Transaktionen!
            </Typography>
            <Typography variant="body1" gutterBottom>
                Bevor die Kasse geschlossen werden kann, müssen folgende Transaktionen abgeschlossen oder abgebrochen werden:
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
                {openTransactions.map((tx) => (
                    <li key={tx.TransactionId}>
                        <Typography variant="body2" className="font-mono">
                            {tx.TransactionId} ({tx.State})
                        </Typography>
                        <Button
                            variant="outlined"
                            onClick={() => onLoad(tx)}
                        >
                            Laden
                        </Button>
                    </li>
                ))}
            </Box>
            <Box mt={2}>
                <Button variant="contained" color="error" onClick={fetchStatus}>
                    Erneut prüfen
                </Button>
            </Box>
        </Paper>
    );
}
